module.exports = __webpack_public_path__ + "img/car-outline-icon.87045e57.svg";